export default {
  // Tabs
  'webConfig.tabs.login': '登录注册配置',
  'webConfig.tabs.thirdParty': '三方注册登录配置',
  'webConfig.tabs.appManage': 'app管理',
  'webConfig.tabs.livechat': 'livechat设置',
  'webConfig.tabs.otherConfig': '其他配置',
  'webConfig.tabs.reportConfig': '监管上报配置',

  // 监管上报配置
  'webConfig.reportConfig.title': '上报比例配置',
  'webConfig.reportConfig.tip': '该配置仅作用于新注册用户，存量用户的 report_status 不受影响。修改保存后立即生效。',
  'webConfig.reportConfig.currentRatio': '当前生效比例',
  'webConfig.reportConfig.report': '（A线路）',
  'webConfig.reportConfig.notReport': '（B线路）',
  'webConfig.reportConfig.lastModify': '最近修改人',
  'webConfig.reportConfig.version': '配置版本号',
  'webConfig.reportConfig.adjustTo': '调整为',
  'webConfig.reportConfig.save': '保存',
  'webConfig.reportConfig.historyTitle': '最近 10 次变更历史',
  'webConfig.reportConfig.col.version': '版本',
  'webConfig.reportConfig.col.time': '变更时间',
  'webConfig.reportConfig.col.operator': '操作人',
  'webConfig.reportConfig.col.change': '旧值 → 新值',
  'webConfig.reportConfig.col.reason': '变更原因',
  'webConfig.reportConfig.confirmTitle': '确认修改上报比例',
  'webConfig.reportConfig.confirmContent': '确认将上报比例调整为 {{ratio}}%？确认后立即生效。',
  'webConfig.reportConfig.reasonPh': '变更原因（可选，便于审计）',
  'webConfig.reportConfig.saveSuccess': '保存成功',
  'webConfig.reportConfig.saveFail': '保存失败',
  'webConfig.reportConfig.fetchError': '加载失败',
  'webConfig.reportConfig.invalidRatio': '请输入 0~100 的整数',

  // 游戏线路自动升级策略
  'webConfig.routeStrategy.title': '游戏线路策略配置',
  'webConfig.routeStrategy.tip': '新用户默认 B 线路，达标后单向升级到 A 线路（不可逆）。两种策略可并存（满足任一即升级）；已手动切换过的会员自动策略不再生效。',
  'webConfig.routeStrategy.strategyTitle': '启用策略',
  'webConfig.routeStrategy.depositStrategy': '按累计存款阈值',
  'webConfig.routeStrategy.vipStrategy': '按 VIP 等级',
  'webConfig.routeStrategy.vipLevelLabel': '升级 VIP 等级',
  'webConfig.routeStrategy.addCurrency': '新增币种',
  'webConfig.routeStrategy.remove': '删除',
  'webConfig.routeStrategy.save': '保存',
  'webConfig.routeStrategy.col.currency': '币种',
  'webConfig.routeStrategy.col.amount': '阈值',
  'webConfig.routeStrategy.col.enabled': '启用',
  'webConfig.routeStrategy.col.action': '操作',
  'webConfig.routeStrategy.saveSuccess': '保存成功',
  'webConfig.routeStrategy.saveFail': '保存失败',
  'webConfig.routeStrategy.fetchError': '加载失败',
  'webConfig.routeStrategy.thresholdInvalid': '启用的币种阈值需填写币种和金额',
  'webConfig.routeStrategy.currencyDuplicate': '币种不可重复',
  'webConfig.routeStrategy.vipLevelRequired': '请填写升级 VIP 等级',

  // Login Register Config
  'webConfig.login.inviteCode': '邀请码开关',
  'webConfig.login.inviteCodeRequired': '邀请码必填：',
  'webConfig.login.outletSelection': '门店选择开关',
  'webConfig.login.agreementManualCheck': '注册页PAGCOR条款勾选',
  'webConfig.login.rgPopupBeforeLogin': 'Responsible Gaming 弹窗（登录前）',
  'webConfig.login.rgPopupAfterLogin': 'Responsible Gaming 弹窗（登录后）',
  'webConfig.login.passwordRisk': '登录密码风控',
  'webConfig.login.passwordRiskMinutes': '分钟 输错',
  'webConfig.login.passwordRiskTimes': '次后冻结',
  'webConfig.login.identityInfo': '身份信息完善：',
  'webConfig.login.phoneOtp': '手机otp验证开关：',
  'webConfig.login.emailOtp': '邮箱otp验证开关：',
  'webConfig.login.isRegKaptcha': '注册验证码开关：',
  'webConfig.login.isRegisterMobileOTP': '注册页手机otp验证开关：',
  'webConfig.login.isBindBankOTP': '绑定提款账号OTP验证开关：',
  'webConfig.login.registerCaptcha': '注册验证码类型：',
  'webConfig.login.captchaType': '验证码类型：',
  'webConfig.login.isLoginKaptcha': '登录验证码开关：',
  'webConfig.login.loginCaptcha': '登录验证码类型：',
  'webConfig.login.isForgetPassKaptcha': '忘记密码验证码开关：',
  'webConfig.login.isStrongPassword': '强密码开关：',
  'webConfig.login.memberPasswordRule': '会员密码校验规则：',
  'webConfig.login.isMultipleDeviceLogin': '多设备登录开关开关：',
  'webConfig.login.forgetKaptchaType': '忘记密码验证码类型：',
  'webConfig.login.captcha.ziyan': '自研验证码',
  'webConfig.login.captcha.yidun': '易盾验证码',
  'webConfig.login.captcha.cloudfare': 'cloudfare验证码',
  'webConfig.login.masterCaptcha': '人机验证总开关：',
  'webConfig.login.masterCaptchaType': '验证码类型：',
  'webConfig.login.applicablePages': '适用页面：',
  'webConfig.login.configurePages': '配置适用页面',
  'webConfig.login.page.login': '登录页获取验证码',
  'webConfig.login.page.forgot': '忘记密码获取验证码',
  'webConfig.login.page.register': '注册页获取验证码',
  'webConfig.login.page.bindPhone': '绑定手机号',
  'webConfig.login.page.bindEmail': '绑定邮箱',
  'webConfig.login.page.bindWithdraw': '绑定提款账户',
  'webConfig.login.page.kioskQuery': '台式机帐密查询接口',
  'webConfig.login.masterCaptchaHint': '开启后，客户端先判断当前页面是否在适用页面范围内；命中页面范围时，点击获取验证码/发送验证码会先弹出人机验证弹窗，验证通过后才发送验证码；验证失败或关闭弹窗则不发送。未命中范围或总开关关闭时，保持原流程直接发送验证码。',
  'webConfig.login.atLeastOnePage': '至少选择一个适用页面',
  'webConfig.login.noPageConfigured': '未配置，人机验证不会生效',
  'webConfig.login.changePassword': '修改密码：',
  'webConfig.login.changePassword.phone': '手机Otp验证',
  'webConfig.login.changePassword.email': '邮箱otp验证',
  'webConfig.login.mobileLoginBg': '移动端登录页背景图：',
  'webConfig.login.mobileRegisterBg': '移动端注册页背景图：',
  'webConfig.login.pcLoginBg': 'PC端登录页背景图：',
  'webConfig.login.pcRegisterBg': 'PC端注册页背景图：',
  'webConfig.login.deviceLimit': '同设备注册限制（开关）：',
  'webConfig.login.deviceLimitTime': '统计时间（小时）：',
  'webConfig.login.deviceNum': '允许注册账号数量：',
  'webConfig.login.ipLimit': '同IP注册限制（开关）：',
  'webConfig.login.ipLimitTime': '统计时间（小时）：',
  'webConfig.login.ipLimitNum': '允许注册账号数量：',
  'webConfig.login.save': '保存',

  // Third Party Config
  'webConfig.thirdParty.google': '谷歌开关：',
  'webConfig.thirdParty.facebook': 'Facebook开关：',
  'webConfig.thirdParty.manualCreate': '三方登录手机认证开关：',
  'webConfig.thirdParty.googleClientId': '谷歌客户端ID：',
  'webConfig.thirdParty.googleAndroidClientId': '谷歌安卓App客户端ID：',
  'webConfig.thirdParty.googleIosClientId': '谷歌ios客户端ID：',
  'webConfig.thirdParty.googleLoginUrl': '谷歌登录地址：',
  'webConfig.thirdParty.facebookAppId': 'Facebook应用ID：',
  'webConfig.thirdParty.facebookAppSecret': 'Facebook应用密钥：',
  'webConfig.thirdParty.facebookLoginUrl': 'Facebook登录地址：',
  'webConfig.thirdParty.appleAppClientId': 'Apple iOS Bundle ID：',

  // App Management
  'webConfig.app.channel': '渠道',
  'webConfig.app.appType': '应用类型',
  'webConfig.app.forceUpgrade': '是否强制升级',
  'webConfig.app.version': '版本号',
  'webConfig.app.downloadUrl': '下载地址',
  'webConfig.app.status': '状态',
  'webConfig.app.status.enabled': '启用',
  'webConfig.app.status.disabled': '禁用',
  'webConfig.app.actions': '操作',
  'webConfig.app.edit': '编辑',
  'webConfig.app.delete': '删除',
  'webConfig.app.disable': '禁用',
  'webConfig.app.enable': '启用',
  'webConfig.app.editTitle': '编辑App配置',
  'webConfig.app.downloadSettings': '应用下载设置',
  'webConfig.app.cancel': '取消',
  'webConfig.app.confirm': '确定',

  // Livechat Config
  'webConfig.livechat.clientId': 'liveChatClientID：',
  'webConfig.livechat.grantType': 'liveChatGrantType：',
  'webConfig.livechat.licenseId': 'liveChatLicenseID：',
  'webConfig.livechat.responseType': 'liveChatResponseType：',
  'webConfig.livechat.redirectUrl': 'liveChatRedirectURL：',
  'webConfig.livechat.backupUrl': '客服备用链接：',

  // SEO - Google Search Console（站点收录/索引统计接入）
  'webConfig.tabs.gsc': 'Google Search Console（SEO 收录统计）',
  'webConfig.gsc.siteUrl': 'GSC 站点属性：',
  'webConfig.gsc.siteUrlDesc': '填 Search Console 中的资源标识，如 sc-domain:example.com 或 https://example.com/',
  'webConfig.gsc.siteBaseUrl': 'SEO 站点根 URL：',
  'webConfig.gsc.siteBaseUrlDesc': '文章页实际所在的站点根，用于拼接 sitemap 与收录检测的绝对 URL。当上面 GSC 属性填的是网域（如 sc-domain:example.com）但文章在子域（如 https://www.example.com）时必填；留空则回退用「GSC 站点属性」。',
  'webConfig.gsc.serviceAccountJson': 'GSC 服务账号 JSON：',
  'webConfig.gsc.serviceAccountJsonPlaceholder': '从 Google Cloud 下载的服务账号 .json 文件，原封不动整段复制粘贴到这里（不要手动编辑）。例如：{ "type": "service_account", "project_id": "...", "private_key": "...", "client_email": "xxx@xxx.iam.gserviceaccount.com", ... }',
  'webConfig.gsc.serviceAccountJsonDesc': '粘贴 Google 服务账号密钥 JSON 全文；该服务账号需在 Search Console 中被添加为该资源的用户。留空则「已索引/主动排除」显示为「-」。',
  'webConfig.gsc.syncBatchSize': '每次同步页数：',
  'webConfig.gsc.syncBatchSizeDesc': '每次定时任务最多检查的页面数（增量轮询，最久未同步的优先）。受 GSC 配额 2000 次/日限制：本值 × 每日运行次数 应 ≤ 2000。如 15 分钟跑一次（96 次/日），建议 ≤ 20。留空默认 20，填 0 = 全量（慎用）。',

  // Other Config
  'webConfig.other.pointExpire': '积分有效期：',
  'webConfig.other.adminGoogleAuth': '运营后台Google验证器：',
  'webConfig.other.kycProcess': 'KYC认证流程开关：',
  'webConfig.other.kycAutoApprove': 'KYC认证申请自动审批开关：',
  'webConfig.other.kycRegisterWithdraw': '提款KYC开关：',
  'webConfig.other.KycAgent': '代理跳过注册KYC：',
  'webConfig.other.isOpenBlackList': 'KYC黑名单校验开关：',
  'webConfig.other.kycWithDrawAgent': '代理跳过提款KYC：',
  'webConfig.other.kycRegisterForce': '注册强制KYC认证：',
  'webConfig.other.KycSimplify': '注册KYC开关：',
  'webConfig.other.KycInterceptorsPath': 'KYC拦截路径：',
  'webConfig.other.withdrawKYCVerifyDateNum': '未通过提款KYC有效时长：',
  'webConfig.other.withdrawKYCVerifyTimes': '提款KYC提醒次数：',
  'webConfig.other.withdrawKYCInterceptorsPath': '未通过提款KYC拦截路径：',
  'webConfig.other.adminLogo': '运营后台logo地址：',
  'webConfig.other.vapeSafeMode': 'vape安全认证模式：',
  'webConfig.other.imageUrl': '图片访问地址：',
  'webConfig.other.gameImageUrl': '游戏图片访问地址：',
  'webConfig.other.payCallbackDomain': '支付回调域名：',
  'webConfig.other.allowedCountries': '前台网站允许访问的国家：',
  'webConfig.other.vipMaxLevel': 'VIP等级最大显示',
  'webConfig.other.vipMaxLevelDesc': '控制前台显示的VIP级别数，请务必把设置的那个级别的成长值调到无穷大',
  'webConfig.other.vipRewardWeeklyPayoutDay': 'VIP周俸祿發放日',
  'webConfig.other.vipRewardWeeklyPayoutDayDesc': '支援數字 1-7（周一=1）、英文 MONDAY..SUNDAY',
  'webConfig.other.vipRewardWeeklyWindowDays': 'VIP周俸祿统计天数',
  'webConfig.other.rtpRange': 'RTP展示区间',
  'webConfig.other.appDownloadLandingPage': 'App下载落地页地址：',
  'webConfig.other.appAndroidDownloadLandingPage': 'App 安卓下载落地页地址：',
  'webConfig.other.appAndroidVersion': 'App 安卓版本号：',
  'webConfig.other.appAndroidForceUpdate': 'App 安卓强制更新：',
  'webConfig.other.activeUserAgent': '活跃用户实体代理：',
  'webConfig.other.activeUserAgentPlaceholder': '请选择活跃用户实体代理',
  'webConfig.other.indexLoading': '开机动画：',
  'webConfig.other.balanceLimit.title': '账户信息 - 手工调账',
  'webConfig.other.balanceLimit.addMax': '增加金额上限：',
  'webConfig.other.balanceLimit.addMaxPlaceholder': '请输入增加金额上限',
  'webConfig.other.balanceLimit.reduceMax': '减少金额上限：',
  'webConfig.other.balanceLimit.reduceMaxPlaceholder': '请输入减少金额上限',
  'webConfig.other.balanceLimit.numberRule': '请输入大于1的数字',
  'webConfig.other.nonNegativeNumberRule': '请输入大于等于0的数字',
  'webConfig.other.pointLimit.title': '会员积分 - 人工调整积分',
  'webConfig.other.pointLimit.addMax': '增加会员积分上限：',
  'webConfig.other.pointLimit.addMaxPlaceholder': '请输入增加会员积分上限',
  'webConfig.other.pointLimit.reduceMax': '减少会员积分上限：',
  'webConfig.other.pointLimit.reduceMaxPlaceholder': '请输入减少会员积分上限',
  'webConfig.other.pointLimit.numberRule': '请输入大于1的数字',
  'webConfig.other.opUserAgentAllocLimit.title': '后台账号→代理 单笔分配上限',
  'webConfig.other.opUserAgentAllocLimit.desc': '控制后台账号一次性给一级代理或二级代理分配额度的上限（PHP / VND / CNY 各自独立）',
  'webConfig.other.opUserAgentAllocLimit.addMax': '单笔加额度上限：',
  'webConfig.other.opUserAgentAllocLimit.addMaxPlaceholder': '请输入单笔加额度上限',
  'webConfig.other.opUserAgentAllocLimit.reduceMax': '单笔减额度上限：',
  'webConfig.other.opUserAgentAllocLimit.reduceMaxPlaceholder': '请输入单笔减额度上限',
  'webConfig.other.agentAllocLimit.title': '代理分配上限',
  'webConfig.other.agentAllocLimit.desc': '控制 L1 一级代理一次性给 L2 二级代理分配额度的上限（仅作用于「调账额度」目标）',
  'webConfig.other.agentAllocLimit.addMax': '单笔加额度上限：',
  'webConfig.other.agentAllocLimit.addMaxPlaceholder': '请输入单笔加额度上限',
  'webConfig.other.agentAllocLimit.reduceMax': '单笔减额度上限：',
  'webConfig.other.agentAllocLimit.reduceMaxPlaceholder': '请输入单笔减额度上限',

  // Common
  'webConfig.common.yes': '是',
  'webConfig.common.no': '否',
  'webConfig.common.saveSuccess': '保存成功',
  'webConfig.common.saveFailed': '保存失败',
  'webConfig.common.updateSuccess': '更新成功',
  'webConfig.common.updateFailed': '更新失败',
  'webConfig.common.disableSuccess': '禁用成功',
  'webConfig.common.disableFailed': '禁用失败',
  'webConfig.common.enableSuccess': '启用成功',
  'webConfig.common.enableFailed': '启用失败',
  'webConfig.common.deleteSuccess': '删除成功',
  'webConfig.common.deleteFailed': '删除失败',

  'webConfig.login.phoneBind': '手机绑定',
  'webConfig.login.emailBind': '邮箱绑定',
  'webConfig.login.allowSkip': '允许跳过',
  'sys.enterCorrectEmail': '请输入正确的邮箱',

  // 字典项显示名：key = dict.<groupCode>.<itemCode>（dict_group_item 的语言中立编码）。
  // 跨模块共用，勿使用后端回传的 item_name / item_name_en 当显示名。
  // 21005 应用类型
  'dict.21005.21005001': 'IOS',
  'dict.21005.21005002': '安卓',
  // 21006 应用渠道
  'dict.21006.21006001': '超级签',
  'dict.21006.21006002': '苹果商店',
  'dict.21006.21006003': '谷歌商店',
  'dict.21006.21006004': 'XIAOMI商店',
  'dict.21006.21006005': 'CHUANYIN商店',
  'dict.21006.21006006': 'VIVO',
  'dict.21006.21006007': 'OPPO',
  'dict.21006.21006008': '华为',
  // 80002 邮件类型／邮件格式
  'dict.80002.80002001': '微软邮箱',
  'dict.80002.80002002': '谷歌邮箱',
  'dict.80002.80002003': 'mailgun',
  // 80003 邮件业务类型
  'dict.80003.80003001': '发送验证码',
};
